import { FC } from 'react';
import { FeaturedEditors, DownloadPageLayout } from '@bpm-web-app/components';

const All: FC<{ title: string }> = ({ title }: { title: string }) => (
    <DownloadPageLayout title={title}>
        <FeaturedEditors indexPage title="Remixers & Editors" />
    </DownloadPageLayout>
);

export default All;

export async function getStaticProps() {
    return {
        props: {
            title: 'Remixers & Editors'
        }
    };
}
